import { serviceProvider, SingletonLifecycle } from "@zebrasoft/core-ui";
import { addWatsonBrowser, ECSLogDecorator, ECSLogger, LogAction } from "@zebrasoft/watson-browser";
import { UrlProvider } from "lib/UrlProvider";
import { LinkstacksLogDecorator } from "./LinkstacksLogDecorator";

const apiKeys = {
    local: "logkey_01knhd3qxdfagr61ta4jv2rx5a",
    test: "logkey_01knhd3x68e3srmhxwhfybkxjb",
    production: "logkey_01knhd41qee7g96ha2qbpd2v4s"
};

addWatsonBrowser({
    apiKey: apiKeys[UrlProvider.environment],
    logServer: "https://watson.zebrasoft.dk/api/ingest/v4"
});

serviceProvider.register(ECSLogDecorator, () => new LinkstacksLogDecorator(), new SingletonLifecycle());

document.addEventListener("DOMContentLoaded", () => {
    const ecsLogger = serviceProvider.resolve<ECSLogger>(ECSLogger);
    ecsLogger.logAction(LogAction.PageHit, "Opened page");
});
